import { render } from "./ResultTPRRanking.vue?vue&type=template&id=48b88373&scoped=true"
import script from "./ResultTPRRanking.vue?vue&type=script&lang=js"
export * from "./ResultTPRRanking.vue?vue&type=script&lang=js"

import "./ResultTPRRanking.vue?vue&type=style&index=0&id=48b88373&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b88373"]])

export default __exports__